import React from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, Alert, Button } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, Storage } from 'react-jhipster';
import { handleSendOtp, handleAddSMS, reset } from '../user.reducer';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import { SUCCESS, ERROR, NUMBER_OTP_FAIL } from 'app/config/constants';
import MessageModal from 'app/shared/message/message-modal';

export interface IFederatedAddModalProps extends StateProps, DispatchProps {
  modalShow: boolean;
  handleClose: Function;
}

export interface IFederatedAddModalState {
  visible: boolean;
  color: string;
  message: string;
  showMessage: boolean;
}

export class FederatedAddModal extends React.Component<IFederatedAddModalProps, IFederatedAddModalState> {
  state: IFederatedAddModalState = {
    visible: false,
    color: 'info',
    message: '',
    showMessage: false
  };

  componentWillReceiveProps(nextProps) {}

  componentWillUnmount() {
    this.props.reset();
  }

  handleValidSubmit = () => {};

  onDismiss = () => {
    this.setState({ visible: false });
  };

  render() {
    return (
      <div>
        <MessageModal type={SUCCESS} showModal={this.state.showMessage} message={'Chúc mừng bạn đã thêm thành công.'} />
        <Modal
          className="hide-border-bottom-modal"
          isOpen={this.props.modalShow}
          toggle={this.props.handleClose}
          backdrop="static"
          centered={window.location === window.parent.location}
        >
          <ModalHeader className="pb-0" toggle={this.props.handleClose} />
          <ModalBody className="padding-modal-body">
            <Row className="justify-content-center bodyModal">
              <Col md="12">
                <h3 className="text-center mb-4">Thêm mới định danh liên kết</h3>
                <AvForm id="register-form" onValidSubmit={this.handleValidSubmit}>
                  <AvField
                    name="gender"
                    label="Loại mã số"
                    type="select"
                    validate={{
                      required: { value: true, errorMessage: 'Bạn phải chọn loại mã số' }
                    }}
                  >
                    <option value="">Chọn loại mã số</option>
                    <option value="1">Nam</option>
                    <option value="0">Nữ</option>
                  </AvField>
                  <AvField
                    name="mobile"
                    label="Mã số"
                    placeholder="Nhập mã số"
                    validate={{
                      required: { value: true, errorMessage: 'Bạn phải nhập mã số' }
                    }}
                  />
                  <Button className="btn-register" type="submit" block>
                    <span className="font-weight-bold">CẬP NHẬT THÔNG TIN</span>
                  </Button>
                </AvForm>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  resSendOtp: storeState.userInfo.resSendOtp,
  response: storeState.userInfo.response
});

const mapDispatchToProps = { handleSendOtp, handleAddSMS, reset };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FederatedAddModal);
